import { Button, Col, Input, Row, Tooltip, Typography } from "antd";
import {
  ContainerData,
  File,
  MetadataCollection,
  MetadataTemplateItem,
} from "../../../api/data-types";

import { MetadataEditModal } from "./metadata-edit-modal";

import "./metadata-preview.css";
import { useEffect, useState } from "react";
import { MetadataMassEditModal } from "./metadata-mass-edit-modal";

const { Title } = Typography;

interface MetadataPreviewProps {
  theme: string;
  selectedContainer: ContainerData;
  selectedFiles: File[];
  closePreview: () => Promise<void>;
  containerAccess?: boolean;
}

export const MetadataPreview = ({
  theme,
  selectedContainer,
  selectedFiles,
  closePreview,
  containerAccess,
}: MetadataPreviewProps) => {
  const [openMetadataEditModalModal, setOpenMetadataEditModal] =
    useState<boolean>(false);

  const [openMetadataMassEditModalModal, setOpenMetadataMassEditModal] =
    useState<boolean>(false);

  const [metadata, setMetadata] = useState<MetadataCollection>(
    new MetadataCollection(selectedContainer.metadataTemplate, {})
  );

  const editMetadataValue = () => {
    setOpenMetadataEditModal(false);
    setOpenMetadataMassEditModal(false);
  };

  useEffect(() => {
    if (selectedFiles.length === 1) {
      setMetadata(selectedFiles[0].metaData);
    }
  }, [selectedFiles]);

  const textColor = theme === "light" ? "#000000" : "#ffffff";

  return (
    <>
      {selectedFiles.length === 1 && (
        <div
          className="previewPanel"
          style={{ overflow: "auto", height: "70vh" }}
        >
          <div>
            <Row>
              <Col span={18}>
                <Title level={5} className="metadataPreview">
                  Metadata from selected file
                </Title>
              </Col>
              <Col span={4} className="editButtonColumn">
                <Tooltip
                  title={
                    containerAccess
                      ? ""
                      : "You can't edit metadata in this container."
                  }
                >
                  <Button
                    disabled={!containerAccess}
                    className="editButton"
                    onClick={() => {
                      setOpenMetadataEditModal(() => true);
                    }}
                  >
                    Edit
                  </Button>
                </Tooltip>
                <MetadataEditModal
                  theme={theme}
                  metadata={metadata}
                  isOpen={openMetadataEditModalModal}
                  sendStateToParent={editMetadataValue}
                  selectedContainer={selectedContainer}
                  selectedFile={selectedFiles[0]}
                  closePreview={closePreview}
                ></MetadataEditModal>
              </Col>
            </Row>
          </div>
          {metadata &&
            Object.entries(metadata?.metadataFromTemplate).map(
              ([key, value]) => (
                <div key={key + value} className="metadataPreview">
                  <Title level={5}>{key}</Title>
                  <Input style={{color:textColor}} value={value} readOnly />
                </div>
              )
            )}
          {metadata &&
            Object.entries(metadata?.otherMetadata).map(([key, value]) => (
              <div key={key} className="metadataPreview">
                <Title level={5}>{key}</Title>
                <Input style={{color:textColor}} value={value} readOnly />
              </div>
            ))}
        </div>
      )}
      {selectedFiles.length !== 1 && (
        <div
          className="previewPanel"
          style={{ overflow: "auto", height: "70vh" }}
        >
          <Row>
            <Col span={18}>
              <Title level={5} className="metadataPreview">
                Selected files
              </Title>
            </Col>
            <Col span={4} className="editButtonColumn">
              <Tooltip
                title={
                  containerAccess
                    ? ""
                    : "You can't edit metadata in this container."
                }
              >
                <Button
                  disabled={!containerAccess}
                  className="editButton"
                  onClick={() => {
                    setOpenMetadataMassEditModal(() => true);
                  }}
                >
                  Edit
                </Button>
              </Tooltip>
              <MetadataMassEditModal
                theme={theme}
                isOpen={openMetadataMassEditModalModal}
                sendStateToParent={editMetadataValue}
                selectedContainer={selectedContainer}
                selectedFiles={selectedFiles}
                closePreview={closePreview}
              ></MetadataMassEditModal>
            </Col>
          </Row>
          <div className="fileList">
            {selectedFiles.map((item) => (
              <Row
                key={item.folderName + item.name}
              >
                {item.name}
              </Row>
            ))}
          </div>
        </div>
      )}
    </>
  );
};
